module.exports = "/assets/53a72928b75a64c4229d5dcd59fdb85c.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/OX.png
// module id = 1696
// module chunks = 0